export default {
  api: {
    somethings_new: 'Vi har noe nytt til deg!',
    notice_changes:
      'Du legger kanskje merke til at noen aktiviteter har endret verdi. Vi prøver alltid å gi deg de mest oppdaterte tallene, derfor har vi nettopp hentet ut de aller ferskeste datakildene for å gi deg disse. Nyt den oppdaterte nøyaktigheten!',
  },
  calculator: {
    better_than_average:
      'BETA - Er klimaavtrykket ditt bedre enn gjennomsnittet? Finn ut ved å prøve denne',
    footprint_calculator: `MARKDOWN:[klimafotavtrykkskalkulatoren](https://openfootprint.ducky.eco/)`,
  },
};
